import React from 'react';
import styles from './Sidebar.module.scss';

import Search from '../Search/Search';
import Filters from '../Filters/Filters';
import Comparison from '../../../Comparison/components/Comparison/Comparison';
import { HydratedCurriculumType } from '../../../Common/types/AppConfigTypes';

interface SidebarProps {
    activeCurriculumType: HydratedCurriculumType;
}

const Sidebar: React.FC<SidebarProps> = props => {
    return (
        <div className={styles.SidebarContainer}>
            <Search curriculumType={props.activeCurriculumType} />
            <Filters curriculumType={props.activeCurriculumType} />
            <Comparison curriculumType={props.activeCurriculumType} />
        </div>
    );
};

export default Sidebar;
